/**
 * Created by RKL on 13/08/2015.
 */
define('kitDetailView',[
  'module',
  'kitCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!kitDetailTabTpl'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl
) {
  'use strict';

  var KitDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        kitModel: this.model
      });
      createEditView.show({
        title: _.i18n('kit.edit')
      });
    }

  });

  module.exports = KitDetailView;
});
